import _typeof from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es.array.concat.js";
import cookies from './util.cookies';
import db from './util.db';
import log from './util.log';
import Cookies from 'js-cookie';
import formatTime from './util.formatTime';
import func from './util.func';
var util = {
  cookies: cookies,
  db: db,
  log: log,
  formatTime: formatTime,
  func: func
};

util.setUserInfo = function (userInfo) {
  cookies.set('userInfo', userInfo, {
    expires: 1
  });
};

util.getUserInfo = function () {
  var userInfo = cookies.get('userInfo');
  return userInfo ? JSON.parse(userInfo) : {};
};

util.setVENDOR_CODE = function (VENDOR_CODE) {
  cookies.set('srm-VENDOR_CODE', JSON.stringify(VENDOR_CODE));
};

util.getVENDOR_CODE = function () {
  var VENDOR_CODE = JSON.parse(cookies.get('srm-VENDOR_CODE')); // console.log('VENDOR_CODE', VENDOR_CODE)

  return VENDOR_CODE;
}; //下游供应商


util.setPARENT_VENDOR_CODE = function (PARENT_VENDOR_CODE) {
  cookies.set('srm-PARENT_VENDOR_CODE', JSON.stringify(PARENT_VENDOR_CODE));
};

util.getPARENT_VENDOR_CODE = function () {
  var PARENT_VENDOR_CODE = JSON.parse(cookies.get('srm-PARENT_VENDOR_CODE')); // console.log('VENDOR_CODE', VENDOR_CODE)

  return PARENT_VENDOR_CODE;
}; //导出任务数


util.setExportMissionNum = function () {
  var num = util.getExportMissionNum() + 1;
  cookies.set('srm-ExportMissionNum', num);
};

util.getExportMissionNum = function () {
  if (cookies.get('srm-ExportMissionNum')) {
    var NUM = JSON.parse(cookies.get('srm-ExportMissionNum'));
    return NUM;
  } else {
    return 0;
  }
};
/**
 * @description 更新标题
 * @param {String} title 标题
 */


util.title = function (titleText) {
  var processTitle = process.env.VUE_APP_TITLE || 'D2Admin';
  window.document.title = "".concat(processTitle).concat(titleText ? " | ".concat(titleText) : '');
};
/**
 * @description 打开新页面
 * @param {String} url 地址
 */


util.open = function (url) {
  var a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('target', '_blank');
  a.setAttribute('id', 'd2admin-link-temp');
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(document.getElementById('d2admin-link-temp'));
};

util.isEmptyWithAllType = function (val) {
  if (val === null || val === undefined || val === '') {
    return true;
  } else if (Array.isArray(val) && val.length === 0) {
    return true;
  } else if (_typeof(val) === 'object' && JSON.stringify(val) === '{}') {
    return true;
  }

  return false;
};

export default util;